import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export const downloadPDF = page => {
    return new Promise(resolve => {
        html2canvas(page, { useCORS: true }).then(function(canvas) {
            // canvas2PDF(canvas)
            const imageUrl = canvas.toDataURL('image/png')
            resolve(imageUrl)
        })
    })
}

const canvas2PDF = canvas => {
    console.log('canvas', canvas)
    const contentWidth = canvas.width
    const contentHeight = canvas.height
    // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    var imgWidth = 595.28
    var imgHeight = (592.28 / contentWidth) * contentHeight
    const PDF = new jsPDF('', 'pt', 'a4')
    PDF.addImage(
        canvas.toDataURL('image/jpeg', 1.0),
        'JPEG',
        0,
        0,
        imgWidth,
        imgHeight
    )
    PDF.save('导出.pdf') // 这里是导出的文件名
}

